import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { RamoService } from '../ramo/shared/ramo.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AmparosService } from '../amparos/shared/amparos.service';
import { AmparoDocumentoService } from './shared/amparo-documento.service';
import { Amparos } from '../amparos/shared/amparos.model';
import { AmparoDocumento } from './shared/amparo-documento.model';
import { Ramo } from '../ramo/shared/ramo';
import * as $ from 'jquery';
import { Select2OptionData } from 'ng-select2';

@Component({
  selector: 'app-documentos-siniestros',
  templateUrl: './documentos-siniestros.component.html'
})

export class DocumentosSiniestrosComponent implements OnInit {
  forSinAmp: FormGroup;
  formDocSin: FormGroup;
  edit: boolean;
  idEdit: number;
  tablaDocumentos: boolean;
  addDocumentFlag: boolean;
  editDocumentFlag: boolean;
  nameAmparo: string;
  valueSelected: string;

  datatableAmp: any;
  datatableDoc: any;

  ListAmparosByRamo: Amparos[] = [];
  ListDocuments: AmparoDocumento[] = [];

  listBouquet: Array<Select2OptionData> = [];

  constructor(
    private amparosService: AmparosService,
    private amparoDocumentoService: AmparoDocumentoService,
    private toastr: ToastrService,
    private ramoService: RamoService,
    private _fb: FormBuilder,
    private chRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.initForm();
    this.loadRamos();
  }

  initForm() {
    this.forSinAmp = this._fb.group({
      idAdmAmparo: 0,
      nombre: ["", [Validators.required]],
      ramo: [[''], [Validators.required]],
      AdmRamoAmparo: null,
    });
    // this.toastr.warning("Para consultar los amparos, porfavor seleccione un ramo")//TODO: Validar Trasnlate
    this.formDocSin = this._fb.group({
      idAdmAmparoDocumento: 0,
      idAdmAmparo: 0,
      nombreAmparo: "",
      nombre: ["", [Validators.required]],
      activo: true
    });
  }

  loadRamos() {
    this.ramoService.getRamo().then(r => {
      let list: Select2OptionData[] = [];
      if (this.ramoService.listRamo != null) {
        list.push({ id: '0', text: 'Seleccione' });
        this.ramoService.listRamo.forEach(item => {
          list.push({ id: item.idAdmRamo.toString(), text: item.nombre });
        });
      }

      this.listBouquet = list;
    });
  }

  ListarDocumentos(idAdmAmparo: number, nombre: string) {
    this.forSinAmp.reset();
    this.tablaDocumentos = true;
    this.addDocumentFlag = false;
    this.nameAmparo = nombre;
    this.idEdit = idAdmAmparo;

    this.amparoDocumentoService.getDocumentsByidAmparo(idAdmAmparo).then(r => {
      if ($.fn.dataTable.isDataTable('#datatableDoc')) {
        this.datatableDoc.destroy();
      }

      this.ListDocuments = r as AmparoDocumento[];

      this.chRef.detectChanges();

      const table: any = $('#datatableDoc');
      this.datatableDoc = table.DataTable({
        responsive: true
      })

    });
  }

  onSubmitAmp() {
    this.insertAmparo();
  }

  onSubmitDoc() {
    this.insertDocumento();
  }


  refreshListByramo(value) {
    this.valueSelected = value;
    this.edit = false;
    this.tablaDocumentos = false;
    this.addDocumentFlag = false;

    if (this.valueSelected == "") {
      this.toastr.warning("Para consultar los amparos, porfavor seleccione un ramo")//TODO: Validar Trasnlate
    } else {
      this.getAmparoByRamo(this.valueSelected);
      //this.amparosService.getAmparosByRamoSini(this.forSinAmp.get("ramo").value);
    }
  }

  getAmparoByRamo(ramo: any) {
    this.amparosService.getAmparosByRamoSini(ramo).then(r => {

      if ($.fn.dataTable.isDataTable('#datatableAmp')) {
        this.datatableAmp.destroy();
      }

      this.ListAmparosByRamo = this.amparosService.listAmparos as Amparos[];

      this.chRef.detectChanges();

      const table: any = $('#datatableAmp');
      this.datatableAmp = table.DataTable({
        responsive: true
      })

    });

  }

  getAmparo(id: number) {
    this.amparosService.getAmparoById(id)
  }

  deleteAmparo(id: number) {
    this.toastr.error("Lo elimine:" + id);
    //this.amparosService.deleteAmparo(id)
  }

  editAmparo(nombreEdit, id) {
    this.edit = true;
    this.idEdit = id;
    this.forSinAmp.patchValue({
      nombre: nombreEdit
    });
  }

  updateAmparo() {
    let valueSubmit = Object.assign({}, this.forSinAmp.value);
    valueSubmit = Object.assign(valueSubmit, {
      AdmRamoAmparo: [],
      idAdmAmparo: this.idEdit
    });
    this.amparosService.updateAmparo(valueSubmit, this.idEdit).then(r => { this.toastr.success('Actualizado correctamente'); this.refreshListByramo(this.valueSelected); this.resetForm() });
    this.edit = false;
    //TODO:Realiza Cambios en mensajes.
  }

  insertAmparo() {
    let valueSubmit = Object.assign({}, this.forSinAmp.value);
    valueSubmit = Object.assign(valueSubmit, {
      AdmRamoAmparo: [{ idAdmRamo: valueSubmit.ramo, aplicaSiniestros: true }]
    });

    this.amparosService.postAmparo(valueSubmit).then(
      r => { this.toastr.success("Dato insertado Correctamente"); this.refreshListByramo(this.valueSelected) }, e => {
        this.toastr.error("this it's a Error"); //TODO: Cambiar mensaje por la versión con translate
      }
    )
  }

  insertDocumento() {
    this.amparoDocumentoService.postDocument(this.formDocSin.value).then(
      r => { this.toastr.success("Dato insertado Correctamente"); this.ListarDocumentos(this.formDocSin.get("idAdmAmparo").value, this.formDocSin.get("nombre").value) }, e => {
        this.toastr.error("this it's a Error"); //TODO: Cambiar mensaje por la versión con translate
      }
    )
  }

  addDocument(id: number, nombre: string) {
    this.addDocumentFlag = true;
    this.editDocumentFlag = false;
    this.formDocSin.patchValue({
      nombreAmparo: nombre,
      idAdmAmparo: id
    });
  }

  resetForm() {
    this.forSinAmp.reset();
  }

  editDocumentoAmparo(nombre: string, id: number) {
    this.addDocumentFlag = true;
    this.editDocumentFlag = true;
    this.formDocSin.patchValue({
      idAdmAmparoDocumento: id,
      nombreAmparo: this.nameAmparo,
      nombre: nombre,
      idAdmAmparo: this.idEdit
    });
  }

  deleteDocumentoAmparo(id: number) {
    this.amparoDocumentoService.deleteDocument(id);
    this.toastr.warning("Eliminado correctamente");;
    this.refreshListByramo(this.valueSelected);
  }

  updateDocument() {
    this.amparoDocumentoService.updateDocument(this.formDocSin.value, this.formDocSin.get('idAdmAmparoDocumento').value).then(r => { this.toastr.success('Actualizado correctamente'); this.refreshListByramo(this.valueSelected); this.resetForm() });
    this.edit = false;
    //CAmbiar los valores y manera de manejar las respuestas.
  }
}
